(() => {
  const pinControllers = new Map();
  const meetControllers = new Map();
  const air = () => {
    const sections = document.querySelectorAll('main .sap-pp > .s81, main .sap-pp.s81');
    let previous = null;
    sections.forEach(section => {
      const transition = section.style.getPropertyValue('transition-property');
      const transitionPriority = section.style.getPropertyPriority('transition-property');
      section.style.setProperty('transition-property', 'none');
      section.removeAttribute('data-tight');
      const currentStyle = getComputedStyle(section);
      const skipped = section.hidden || currentStyle.display === 'none' || section.hasAttribute('data-loose');
      if (!skipped && previous) {
        const previousStyle = getComputedStyle(previous);
        if (previousStyle.backgroundColor === currentStyle.backgroundColor && parseFloat(previousStyle.paddingBottom) >= 40 && parseFloat(currentStyle.paddingTop) >= 40) section.setAttribute('data-tight', '');
      }
      section.getBoundingClientRect();
      if (transition) section.style.setProperty('transition-property', transition, transitionPriority);
      else section.style.removeProperty('transition-property');
      if (!skipped) previous = section;
    });
  };
  const init = root => {
    root.querySelectorAll('.sap-pp[data-o-pin3="short"] .x1-top__grid').forEach(grid => {
      if (pinControllers.has(grid)) return;
      const gallery = grid.querySelector('.x1-gal');
      const info = grid.querySelector('.x1-info');
      if (!gallery || !info) return;
      const columns = [gallery, info];
      let frame = 0;
      const clear = column => {
        column.classList.remove('x3-pin');
        column.style.removeProperty('--x3-pin-top');
      };
      const measure = () => {
        frame = 0;
        const galleryBox = gallery.getBoundingClientRect();
        const infoBox = info.getBoundingClientRect();
        if (innerWidth < 768 || !galleryBox.width || !infoBox.width || galleryBox.right > infoBox.left + 1 || Math.abs(galleryBox.height - infoBox.height) < 8) {
          columns.forEach(clear);
          return;
        }
        const shorter = galleryBox.height < infoBox.height ? gallery : info;
        const height = shorter === gallery ? galleryBox.height : infoBox.height;
        const offset = parseFloat(getComputedStyle(grid.closest('.sap-pp')).getPropertyValue('--x1-pin')) || 172;
        const top = Math.min(offset, innerHeight - height - 24);
        columns.filter(column => column !== shorter).forEach(clear);
        shorter.style.setProperty('--x3-pin-top', top + 'px');
        shorter.classList.add('x3-pin');
      };
      const schedule = () => { if (!frame) frame = requestAnimationFrame(measure); };
      const observer = new ResizeObserver(schedule);
      columns.forEach(column => observer.observe(column));
      grid.addEventListener('toggle', schedule, true);
      grid.addEventListener('change', schedule);
      grid.addEventListener('load', schedule, true);
      window.addEventListener('resize', schedule);
      measure();
      pinControllers.set(grid, () => {
        cancelAnimationFrame(frame);
        observer.disconnect();
        grid.removeEventListener('toggle', schedule, true);
        grid.removeEventListener('change', schedule);
        grid.removeEventListener('load', schedule, true);
        window.removeEventListener('resize', schedule);
        columns.forEach(clear);
      });
    });
    const descriptionLabels = document.querySelector('script[data-pp-read-more]')?.dataset;
    if (descriptionLabels && typeof Intl.Segmenter === 'function') root.querySelectorAll('.sap-pp .x1-top .x1-lede > .t-body, .sap-ritual-set .x1-top .x3-id__short').forEach((description, index) => {
      if (description.hasAttribute('data-pp-description')) return;
      const words = description.innerText.trim();
      const first = new Intl.Segmenter(document.documentElement.lang || 'en', { granularity: 'sentence' }).segment(words)[Symbol.iterator]().next().value?.segment.trim();
      if (!first || first === words) return;
      const preview = description.cloneNode(false);
      preview.removeAttribute('id');
      preview.setAttribute('data-pp-description-preview', '');
      preview.textContent = first;
      description.setAttribute('data-pp-description', '');
      description.id ||= 'pp-description-' + (description.closest('[id^="shopify-section-"]')?.id || 'top') + '-' + index;
      const button = document.createElement('button');
      button.type = 'button';
      button.setAttribute('data-pp-description-toggle', '');
      button.setAttribute('aria-controls', description.id);
      let expanded = false;
      const phone = matchMedia('(max-width: 767px)');
      const sync = () => {
        preview.hidden = !phone.matches || expanded;
        description.hidden = phone.matches && !expanded;
        button.hidden = !phone.matches;
        button.setAttribute('aria-expanded', String(expanded));
        button.textContent = expanded ? descriptionLabels.ppReadLess : descriptionLabels.ppReadMore;
      };
      description.before(preview);
      description.after(button);
      button.addEventListener('click', () => {
        const position = { left: scrollX, top: scrollY, behavior: 'instant' };
        expanded = !expanded;
        sync();
        button.focus({ preventScroll: true });
        scrollTo(position);
        requestAnimationFrame(() => scrollTo(position));
      });
      phone.addEventListener('change', sync);
      sync();
    });
    root.querySelectorAll('[data-pp-standards]').forEach(details => {
      if (details.dataset.ppReady) return;
      details.dataset.ppReady = 'true';
      details.open = false;
    });
    root.querySelectorAll('[data-ingredient-rail]').forEach(group => {
      if (group.dataset.ppReady) return;
      group.dataset.ppReady = 'true';
      const rail = group.querySelector('.sap-pp-ingredients__rail');
      const controls = group.closest('section').querySelector('[data-x16-nav="ingredients"]');
      if (!controls) return;
      const prev = controls.querySelector('[data-x16-go="-1"]');
      const next = controls.querySelector('[data-x16-go="1"]');
      prev.setAttribute('aria-controls', rail.id);
      next.setAttribute('aria-controls', rail.id);
      const sync = () => {
        controls.hidden = !matchMedia('(min-width: 768px)').matches || rail.scrollWidth <= rail.clientWidth + 2;
        prev.setAttribute('aria-disabled', String(rail.scrollLeft < 2));
        next.setAttribute('aria-disabled', String(rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2));
      };
      const move = direction => rail.scrollBy({left: direction * (rail.firstElementChild.getBoundingClientRect().width + (parseFloat(getComputedStyle(rail).columnGap) || 0)), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      prev.addEventListener('click', () => { if (prev.getAttribute('aria-disabled') === 'true') return; move(-1); }); next.addEventListener('click', () => { if (next.getAttribute('aria-disabled') === 'true') return; move(1); });
      rail.addEventListener('scroll', sync, {passive:true}); new ResizeObserver(sync).observe(rail); sync();
    });
    root.querySelectorAll('[data-pp-video]').forEach(wrapper => {
      if (wrapper.dataset.ppReady) return;
      wrapper.dataset.ppReady = 'true';
      const video = wrapper.querySelector('video');
      const toggle = wrapper.querySelector('[data-pp-video-toggle]');
      if (!video || !toggle) return;
      const galleryMode = wrapper.closest('[data-pp-gallery]')?.dataset.ppGalleryMode;
      const silent = galleryMode === 'silent';
      if (silent || galleryMode === 'tutorial') {
        video.controls = false;
        video.muted = silent;
        video.loop = silent;
      }
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      video.removeAttribute('autoplay'); video.autoplay = false;
      toggle.hidden = false;
      const sync = () => {
        toggle.textContent = video.paused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel;
        toggle.classList.toggle('sap-pp-video__toggle--quiet', silent && !video.paused);
        toggle.toggleAttribute('data-pp-playing', !video.paused);
      };
      const play = () => video.play().catch(sync);
      toggle.addEventListener('click', () => { if (video.paused) play(); else video.pause(); });
      if (galleryMode === 'tutorial') video.addEventListener('click', () => { if (video.paused) play(); else video.pause(); });
      video.addEventListener('play', sync); video.addEventListener('pause', sync); video.addEventListener('ended', sync);
      reduced.addEventListener('change', () => { if (reduced.matches) video.pause(); });
      if (reduced.matches) video.pause();
      if (silent || wrapper.dataset.autoplayIntent === 'true') {
        let attempted = false;
        new IntersectionObserver(entries => {
          if (!attempted && entries[0].isIntersecting && !reduced.matches) { attempted = true; play(); }
        }, {threshold:0.25}).observe(video);
      }
      sync();
    });
    root.querySelectorAll('.sap-pp [role="tablist"]').forEach(bar => {
      if (bar.dataset.ppReady) return;
      bar.dataset.ppReady = 'true';
      const tabs = [...bar.querySelectorAll('[role="tab"]')];
      const cards = bar.hasAttribute('data-x2-tabs') ? bar.closest('[data-x2-meet]')?.querySelector('[data-x2-row]') : null;
      const panels = tabs.map(tab => document.getElementById(tab.getAttribute('aria-controls')));
      let selected = Math.max(0, tabs.findIndex(tab => tab.getAttribute('aria-selected') === 'true'));
      let settling = 0;
      let pending = null;
      const select = (tab, move = true) => {
        selected = tabs.indexOf(tab);
        if (cards && move) pending = selected;
        tabs.forEach(button => {
          const active = button === tab;
          button.setAttribute('aria-selected', String(active));
          button.tabIndex = active ? 0 : -1;
          const panel = document.getElementById(button.getAttribute('aria-controls'));
          if (panel) {
            panel.hidden = cards ? false : !active;
            if (cards) panel.inert = !active;
          }
        });
        if (cards && move) {
          cards.scrollTo({left: cards.scrollLeft, behavior: 'instant'});
          cards.scrollTo({left: selected * cards.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        }
      };
      tabs.forEach((tab,index) => {
        tab.addEventListener('click', () => select(tab));
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next === undefined) return;
          event.preventDefault(); select(tabs[next]); tabs[next].focus({preventScroll: Boolean(cards)});
        });
      });
      if (cards) {
        cards.setAttribute('data-pp-snap', '');
        select(tabs[selected], false);
        const sync = () => {
          clearTimeout(settling);
          if (!cards.clientWidth) return;
          if (pending !== null) {
            if (Math.abs(cards.scrollLeft - pending * cards.clientWidth) > 1) cards.scrollTo({left: pending * cards.clientWidth, behavior: 'instant'});
            pending = null;
          }
          const next = Math.max(0, Math.min(tabs.length - 1, Math.round(cards.scrollLeft / cards.clientWidth)));
          const moveFocus = panels.some((panel, index) => index !== next && panel?.contains(document.activeElement));
          select(tabs[next], false);
          if (moveFocus) tabs[next].focus({preventScroll: true});
        };
        let frame = 0;
        const follow = () => {
          frame = 0;
          if (pending !== null || !cards.clientWidth) return;
          const next = Math.max(0, Math.min(tabs.length - 1, Math.round(cards.scrollLeft / cards.clientWidth)));
          if (next === selected) return;
          const focused = document.activeElement;
          const moveFocus = (tabs.includes(focused) && focused !== tabs[next]) || panels.some((panel, index) => index !== next && panel?.contains(focused));
          select(tabs[next], false);
          if (moveFocus) tabs[next].focus({preventScroll: true});
        };
        const schedule = () => {
          clearTimeout(settling);
          settling = setTimeout(sync, 160);
          if (!frame) frame = requestAnimationFrame(follow);
        };
        const interrupt = () => { pending = null; };
        let width = 0;
        const observer = new ResizeObserver(() => {
          if (width === cards.clientWidth) return;
          width = cards.clientWidth;
          cards.scrollTo({left: selected * width, behavior: 'instant'});
        });
        cards.addEventListener('scroll', schedule, {passive: true});
        cards.addEventListener('scrollend', sync);
        cards.addEventListener('pointerdown', interrupt);
        cards.addEventListener('wheel', interrupt, {passive: true});
        observer.observe(cards);
        meetControllers.set(bar, () => {
          clearTimeout(settling);
          cancelAnimationFrame(frame);
          observer.disconnect();
          cards.removeEventListener('scroll', schedule);
          cards.removeEventListener('scrollend', sync);
          cards.removeEventListener('pointerdown', interrupt);
          cards.removeEventListener('wheel', interrupt);
        });
      }
    });
    root.querySelectorAll('.sap-pp .x1-ba__thumbs').forEach(bar => {
      if (bar.dataset.ppReady) return;
      bar.dataset.ppReady = 'true';
      const row = bar.previousElementSibling;
      const buttons = [...bar.querySelectorAll('button')];
      let movingToPair = false;
      buttons.forEach((button,index) => button.addEventListener('click', () => {
        movingToPair = true;
        row.children[index]?.scrollIntoView({block:'nearest',inline:'start',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
        buttons.forEach((b,i)=>b.setAttribute('aria-pressed',String(i===index)));
      }));
      const syncPair = () => {
        if (movingToPair) return;
        const start = row.getBoundingClientRect().left;
        const distances = [...row.children].map(pair => Math.abs(pair.getBoundingClientRect().left - start));
        const nearest = distances.indexOf(Math.min(...distances));
        buttons.forEach((button, index) => button.setAttribute('aria-pressed', String(index === nearest)));
      };
      row.addEventListener('scroll', syncPair, { passive: true });
      row.addEventListener('scrollend', () => { movingToPair = false; syncPair(); });
      row.addEventListener('pointerdown', () => { movingToPair = false; });
      row.addEventListener('wheel', () => { movingToPair = false; }, { passive: true });
    });
    root.querySelectorAll('[data-x16-nav]:not([data-x16-nav="ingredients"])').forEach(nav => {
      if (nav.dataset.ppReady) return;
      nav.dataset.ppReady = 'true';
      const section = nav.closest('section');
      const controls = [...section.querySelectorAll('[data-x2-tabs] [role="tab"], .x1-ba__thumbs button')];
      if (controls.length < 2) return;
      const buttons = [...nav.querySelectorAll('button')];
      const at = () => Math.max(0, controls.findIndex(control => control.getAttribute('aria-selected') === 'true' || control.getAttribute('aria-pressed') === 'true'));
      const sync = () => {
        nav.hidden = !matchMedia('(min-width: 768px)').matches;
        const index = at();
        const focused = document.activeElement;
        buttons[0].disabled = index === 0;
        buttons[1].disabled = index === controls.length - 1;
        if (focused === buttons[0] && buttons[0].disabled) buttons[1].focus({ preventScroll: true });
        if (focused === buttons[1] && buttons[1].disabled) buttons[0].focus({ preventScroll: true });
      };
      nav.addEventListener('click', event => {
        const button = event.target.closest('[data-x16-go]');
        if (!button || button.disabled) return;
        controls[at() + Number(button.dataset.x16Go)]?.click();
        sync();
      });
      new MutationObserver(sync).observe(controls[0].parentNode, { attributes: true, subtree: true, attributeFilter: ['aria-selected', 'aria-pressed'] });
      matchMedia('(min-width: 768px)').addEventListener('change', sync);
      sync();
    });
  };
  document.addEventListener('click', event => {
    const anchor = event.target.closest('.sap-pp a[href^="#"]');
    if (!anchor) return;
    const target = document.getElementById(anchor.hash.slice(1)) || document.querySelector('.sap-pp [data-x1-anchor="'+anchor.hash.slice(1)+'"]');
    if (!target) return;
    if (target.tagName === 'DETAILS') target.open = true;
    if (anchor.hasAttribute('data-x4-open')) document.getElementById(anchor.getAttribute('data-x4-open'))?.setAttribute('open','');
  });
  init(document);
  air();
  window.addEventListener('load', air);
  window.addEventListener('resize', air);
  document.addEventListener('shopify:section:load', event => { init(event.target); air(); });
  document.addEventListener('shopify:section:unload', event => {
    for (const [grid, cleanup] of pinControllers) if (event.target.contains(grid)) { cleanup(); pinControllers.delete(grid); }
    for (const [bar, cleanup] of meetControllers) if (event.target.contains(bar)) { cleanup(); meetControllers.delete(bar); }
  });
})();
